import React from "react"
import styled from "styled-components"

const Label = (props) => {
  const Label = styled(props.elem).attrs((styledProps) => ({
    ...props,
  }))`
    font-size: 1rem;
    font-weight: 600;
    display: flex;
    line-height: 1;
    white-space: nowrap;

    ${(styledProps) =>
      props.captitalise
        ? `
            text-transform: uppercase;
        `
        : null}
  `

  return <Label {...props}>{props.children}</Label>
}

Label.defaultProps = {
  elem: "div",
}

export default Label
